// One item's CPL deals this month and next, on the item screen: every tier and RIP, the real cost per bottle, and how long it would last.
import { useState } from 'react';
import { api, monthLabel, usd } from '../lib/api';
import { ErrorNote, useLoad } from './ui';

export default function ItemCplDeals({ itemId }: { itemId: string }) {
  const [open, setOpen] = useState(false);
  const [maxDays, setMaxDays] = useState(60);
  const r = useLoad(() => (open ? api<any>(`/api/checks/items/${itemId}/cpl?maxDays=${maxDays}`) : Promise.resolve(null)), [itemId, open, maxDays]);
  const [month, setMonth] = useState(1);
  const d = r.data;
  const m = d?.months[month];
  return (
    <details className="stack-s" style={{ marginTop: 12 }} onToggle={(e) => setOpen((e.target as HTMLDetailsElement).open)}>
      <summary style={{ cursor: 'pointer', fontWeight: 650 }}>CPL deals for this item</summary>
      <ErrorNote error={r.error} />
      {open && !d && !r.error && <div className="faint">Loading…</div>}
      {d && (
        <>
          <div className="faint">
            {d.stock.on_hand} on hand{d.stock.on_order ? `, ${d.stock.on_order} on order` : ''} · sells about {d.stock.per_day}/day
            {d.stock.days_left != null ? ` · about ${d.stock.days_left} days left` : ' · no recent sales'}
          </div>
          <div className="row wrap">
            {d.months.map((x: any, i: number) => <button key={x.sale_month} className={month === i ? 'primary' : ''} onClick={() => setMonth(i)}>{monthLabel(`${x.sale_month}-01`)}</button>)}
            <label className="row" style={{ display: 'flex' }}>Don’t buy more than
              <select value={maxDays} onChange={(e) => setMaxDays(Number(e.target.value))} style={{ width: 'auto' }}>{[30, 45, 60, 90, 120].map((n) => <option key={n} value={n}>{n} days</option>)}</select></label>
          </div>
          {m?.buy_list?.best && <div className="notice">The {monthLabel(`${m.sale_month}-01`)} buy list says: {m.buy_list.best.cases} case(s){m.buy_list.wholesaler ? ` from ${m.buy_list.wholesaler}` : ''}{m.buy_list.best.gainCents > 0 ? `, about ${usd(m.buy_list.best.gainCents)} extra profit` : ''}.</div>}
          {m?.wholesalers.length === 0 && <div className="empty">Not on the {monthLabel(`${m.sale_month}-01`)} CPL{month === 1 ? ' yet (it is public around the 18th)' : ''}.</div>}
          {m?.wholesalers.map((w: any) => (
            <div key={w.wholesaler} className="stack-s">
              <div><b>{w.wholesaler}</b> <span className="faint">· frontline {usd(w.frontline_case_cents)}/case ({usd(w.frontline_unit_cents)} a bottle), {w.case_pack}/case{w.rips.length ? ` · RIP ${w.rips.map((x: any) => x.code).join(', ')}` : ''}</span></div>
              <div className="table-wrap"><table className="grid">
                <thead><tr><th className="n">Buy</th><th className="n">Invoice</th><th className="n">RIP back</th><th className="n">Per bottle</th><th className="n">Saved</th><th className="n">Lasts</th><th /></tr></thead>
                <tbody>{w.options.map((o: any) => {
                  const best = w.best_within_limit?.bottles === o.bottles;
                  return (
                    <tr key={o.bottles} style={o.overbuy ? { opacity: 0.55 } : undefined}>
                      <td className="n">{Number.isInteger(o.cases) ? `${o.cases} cs` : `${o.bottles} btl`}</td>
                      <td className="n">{usd(o.invoice_cents)}</td>
                      <td className="n">{o.rip_cents ? usd(o.rip_cents) : '—'}</td>
                      <td className="n" style={{ fontWeight: 650 }}>{usd(o.net_unit_cents)}</td>
                      <td className="n">{o.saving_total_cents > 0 ? usd(o.saving_total_cents) : '—'}</td>
                      <td className="n">{o.days_of_stock == null ? '—' : `${o.days_of_stock} days`}</td>
                      <td>{best ? <span className="chip good">Best buy</span> : o.overbuy ? <span className="chip warn">Too much</span> : null}</td>
                    </tr>);
                })}</tbody>
              </table></div>
            </div>
          ))}
          <p className="faint">Per bottle is after the RIP check. “Lasts” counts what you have and what is on order. Order from Purchase orders or the Buy list.</p>
        </>
      )}
    </details>
  );
}
